import { cloneElement, isValidElement } from "react";
import Select, { components } from "react-select";
import { HStack, Text, Box, Image } from "@chakra-ui/react";

const OptionLabel = ({ label, icon, img, rtl }) => {
  return (
    <HStack
      justify="space-between"
      gridGap="10px"
      flexDir={rtl ? "row-reverse" : "row"}
    >
      <Text
        fontWeight="500"
        overflow="hidden"
        whiteSpace="nowrap"
        textOverflow="ellipsis"
      >
        {label}
      </Text>
      {icon && <Box as={icon} m="0 !important" />}
      {/* {img && ( */}
      {img && (
        <Box
          w="20px"
          h="20px"
          borderRadius="4px"
          as={Image}
          src={img}
          objectFit="contain"
          alt=""
          m="0 !important"
        />
      )}
      {/* )} */}
    </HStack>
  );
};

const SingleValue = ({ children, ...props }) => {
  const value = props?.getValue()[0];
  if (isValidElement(value?.label))
    return cloneElement(value?.label, { rtl: true, ...props });
  return <components.SingleValue {...props}>{children}</components.SingleValue>;
};

const RSelect = ({ options, ...rest }) => {
  const styles = {
    container: () => ({
      width: "100%",
      height: "50px",
      position: "relative",
      ...rest?.container,
    }),
    control: (base, props) => ({
      ...base,
      height: "56px",
      marginTop: "0px",
      marginLeft: "2px",
      borderRadius: "16px",
      background: "#eff0f7",
      padding: "0 10px",
      borderColor: "transparent !important",
      boxShadow: props.isFocused ? "0 0 0 3px #14e4648f" : "0",
      ":hover": {
        background: "#E2E8F0",
        borderColor: "#14e464",
        boxShadow: "0 0 0 3px #14e4648f",
      },
      ":focus": {
        borderColor: "#14e464",
        boxShadow: "0 0 0 3px #14e4648f",
      },

      ...rest?.control,
    }),
    valueContainer: (base, props) => ({
      ...base,
      ...rest?.valueContainer,
    }),
    dropdownIndicator: () => ({
      ...rest?.dropdownIndicator,
    }),
    indicatorsContainer: (base, props) => ({
      ...base,
      ...rest?.indicatorsContainer,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (base, _) => ({
      ...base,
      margin: "4px 0",
      overflow: "hidden",
      boxShadow: "0 4px 11px hsl(0deg 0% 0% / 10%)",
      width: "100%",
      zIndex: 2,
    }),
    menuList: (base, _) => ({
      ...base,
      padding: 0,
    }),
    option: (base, props) => ({
      ...base,
      height: "fit-content",
      background: props.isSelected ? "#14e464" : "transparent",
      ":active": {
        background: "#14e464",
      },
      ":hover": {
        background: "#14e46480",
      },
    }),
    menuPortal: (base, props) => ({
      ...base,
    }),
  };

  return (
    <Select
      options={options}
      styles={styles}
      components={{ SingleValue }}
      {...rest}
    />
  );
};

export { RSelect, OptionLabel };
